import { SeverityRow } from "@interfaces/analysis";
import { MenuItem, Popover, Typography } from "@mui/material";

interface AnalysisPopoverProps {
  anchorElement: Element | undefined;
  severityRow: SeverityRow;
  handleCloseMenu: () => void;
}
export const AnalysisPopover = ({
  anchorElement,
  severityRow,
  handleCloseMenu,
}: AnalysisPopoverProps) => {
  return (
    <Popover
      style={{ pointerEvents: "none" }}
      open={Boolean(anchorElement)}
      anchorEl={anchorElement}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: "center", horizontal: "left" }}
      transformOrigin={{ vertical: "center", horizontal: "right" }}
      PaperProps={{
        sx: {
          p: 1,
          width: 140,
          "& .MuiMenuItem-root": {
            px: 1,
            typography: "body2",
            borderRadius: 0.75,
          },
        },
      }}
    >
      <MenuItem key={`menu-item-projected-value`}>
        <Typography ml={1}>
          {`Performance ${(
            (100 * severityRow.total) /
            severityRow.totalTarget
          ).toLocaleString()}%`}
        </Typography>
      </MenuItem>
      <MenuItem key={`menu-item-overall-target`}>
        <Typography ml={1}>
          {`Target ${severityRow.totalTarget.toLocaleString()}`}
        </Typography>
      </MenuItem>
      <MenuItem key={`menu-item-total`}>
        <Typography
          ml={1}
        >{`Achieved ${severityRow.total.toLocaleString()}`}</Typography>
      </MenuItem>
      <MenuItem key={`menu-item-actual-value`}>
        <Typography ml={1}>
          {`${severityRow.pcChange.toLocaleString()}%`}
        </Typography>
      </MenuItem>
    </Popover>
  );
};
